const userConfig = require('../../.env.js');

export default userConfig;
